import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { DatePickerLocaleModule } from '../date-picker-locale/date-picker-locale.module';
import { SelectModule } from '../select/select.module';
import { PipeModule } from '../pipe/pipe.module';
import { ConsumptionInfoCorrectionDialogComponent } from './consumption-info-correction-dialog.component';

@NgModule({
	declarations: [ConsumptionInfoCorrectionDialogComponent],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatDialogModule,
		MatButtonModule,
		MatIconModule,
		TranslateModule.forChild(),
		DatePickerLocaleModule,
		SelectModule,
		PipeModule,
	],
	exports: [ConsumptionInfoCorrectionDialogComponent],
})
export class ConsumptionInfoCorrectionDialogModule {}
